export default {
	"goodsType": {
		"keyWordEmptyTips": "Keywords can not be empty ",
		"priority": "priority",
		"code": "type code",
		"defaultTemperatureType": "default temperature control type",
		"defaultTemperatureRange": "default temperature control range",
		"keyword": "keywords",
		"keywordTips": "keywords (enter to add)",
		"addGoodsType": "Add item type",
		"onlyCreateGoodsTypeSelectTips": "Only item types with new status can be selected",
		"onlyEnableGoodsTypeSelectTips": "Only active item types can be selected"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/goodsType/goodsType.js